import { gql } from '../../../apollo/__generated__';

export const STAFF_REFUND_TRANSACTION = gql(`
  mutation StaffRefundTransaction($transactionId: ID!) {
    staffRefundTransaction(transactionId: $transactionId) {
      id
      status
    }
  }
`);
